import Action from '../action';

export const SECURITY_GROUPS_RETRIEVAL_INITIATED = 'SECURITY_GROUPS_RETRIEVAL_INITIATED';
export const SECURITY_GROUPS_RETRIEVAL_FAILED = 'SECURITY_GROUPS_RETRIEVAL_FAILED';
export const SECURITY_GROUPS_RETRIEVED = 'SECURITY_GROUPS_RETRIEVED';

export const fetch = () => Action(SECURITY_GROUPS_RETRIEVAL_INITIATED);
export const fetchSuccess = groups => Action(SECURITY_GROUPS_RETRIEVED, groups);
export const fetchFailure = error => Action(SECURITY_GROUPS_RETRIEVAL_FAILED, error, true);
